import React from 'react';
import { useHistory } from 'react-router-dom';
import ScreenLayout from 'components/ScreenLayout';
import RoomOptionsContent from './components';
// import MobileFooter from 'components/MobileFooter';

const RoomOptionsScreen: React.FC = () => {

  useHistory();


  return (
    <ScreenLayout>
      <RoomOptionsContent />
      {/* <MobileFooter handleContinueBooking={handleContinueBooking}/> */}
    </ScreenLayout>
  );
}

export default RoomOptionsScreen;
